<template>
  <div class="detail-padding">
    <div class="spaceBetween" style="margin-bottom:0.24rem">
      <div class="spaceLeft">
        <div class="detail-title-1">Auction Pool</div>
        <el-button type="text" class="upper b-c" style="margin-left:0.16rem;" @click="toBidList">My&ensp;bidding&ensp;history&ensp;<i class="el-icon-d-arrow-right"/></el-button>
      </div>
      <div class="spaceLeft search-form">
        <!-- <div class="sapceLeft search-item">
          <el-checkbox v-model="searchParams.status" @change="getList">Auctioned</el-checkbox>
        </div> -->
        <search-date @dateChange="dateChange($event,'overtime')" label="Closing time"/>
        <div class="sapceLeft search-item">
          <el-input v-model="searchParams.number" placeholder="No..." suffix-icon="el-icon-search" @change="getList"/>
        </div>
      </div>
    </div>

    <div class="common-card is-border">
      <div class="common-card-main">
        <el-table class="common-table" :data="tableList" v-loading="loading">
          <el-table-column prop="number" label="Bid No." align="left"/>
          <el-table-column prop="amount" label="Auction" align="right">
            <template slot-scope="{ row }">
              <big-number :number="row.amount"/>
              <span class="td-word-sm">UNIT</span>
            </template>
          </el-table-column>
          <el-table-column prop="startAmount" label="Reserve price" align="right">
            <template slot-scope="{ row }">
              <big-number :number="row.startAmount"/>
              <span class="td-word-sm">TCash</span>
            </template>
          </el-table-column>
          <el-table-column prop="overtime" label="Closing time" align="center">
            <template slot-scope="{ row }">
              {{ moment(row.overtime).format("YYYY-MM-DD HH:mm:ss") }}
            </template>
          </el-table-column>
          <el-table-column prop="highValue" label="Current bid" align="right">
            <template slot-scope="{ row }">
              <big-number :number="row.highValue"/>
              <span class="td-word-sm">TCash</span>
            </template>
          </el-table-column>
          <el-table-column prop="operation" label="operation" align="right">
            <template slot-scope="{ row }">
              <el-button
                class="o-btn"
                @click="toPlaceBid(row)">
                <span>Place a bid</span>
              </el-button>
              <!-- <div class="pointer spaceRight" @click="toPlaceBid(row)">
                <img src="@/assets/image/placeBid/placeBid.png" style="height:0.18rem;">
                <span style="color:#225BFC;font-size:0.18rem;margin-left:0.08rem;">Place a bid</span>
              </div> -->
            </template>
          </el-table-column>
        </el-table>
        <pagination
          :total.sync="queryParams.total"
          :page.sync="queryParams.page"
          :limit.sync="queryParams.pageSize"
          @pagination="getList()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { auctionList } from "@/api/auction.js"
export default {
  components: {},
  data() {
    return {
      loading: true,
      searchParams:{
        Auctioned:false,
        overtime:[],
        number:undefined
      },
      queryParams: {
        total: 0,
        page: 1,
        pageSize: 10
      },
      tableList: []
    };
  },
  computed: {},
  methods: {
    init(){
      this.getList();
    },
    dateChange(data, prop){
      this.searchParams[prop] = data;
      this.getList();
    },
    getList() {
      this.loading = true;
      auctionList({
        status:this.searchParams.status ? "3" : "",
        number:this.searchParams.number,
        overTimeFrom:this.searchParams.overtime[0] ? this.moment(this.searchParams.overtime[0]).format("x")  : undefined,
        overTimeTo:this.searchParams.overtime[1] ? this.moment(this.searchParams.overtime[1]).format("x")  : undefined,
        pageSize:this.queryParams.pageSize,
        page:this.queryParams.page,
      }).then(res => {
        this.tableList = res.data ? res.data.data : [];
        this.queryParams.total = res.data.total || 0;
        this.loading = false;
      }).catch(e => {
        this.loading = false;
      })
    },
    toPlaceBid(row){
      this.$router.push({
        path:"/TCashFinance/auction/placeBid",
        query:{
          ...row
        }
      })
    },
    toBidList(){
      this.$router.push("/TCashFinance/auction/placeBid/record");
    }
  },
  created() {
    this.init();
  }
};
</script>
<style scoped lang="scss">
.b-c {
  color: rgba(38, 117, 241, 1)!important;
}

.search-item >>> input {
  border: 1px solid rgba(255,255,255,0.2)!important;
}

.common-table {
  >>> .el-loading-mask {
    background-color: rgba(0, 0, 0, .6);
  }

  >>> .el-loading-spinner .path {
    stroke: #2675f1;
  }

  .o-btn {
    width: 1.39rem;
    height: 0.44rem;
    border-radius: 0.06rem;
    font-size: 0.18rem;
    background: linear-gradient(264deg, #225bfc 0%, #062567 100%);
    cursor: pointer;
    color: #ffffff;
    border: 0;
  }
}

// .common-table {
//   ::v-deep  &.el-table {
//     font-size: 0.16rem;
//     background:#f5f5f5;

//     .el-table__header-wrapper th {
//       background:#f5f5f5;
//       height: 0.2rem;
//       font-size: 0.16rem;
//       padding: 0 0 0.25rem 0;
//       font-weight: normal;
//     }
//     th.is-leaf{
//       border-bottom: none;
//     }
//     td {
//       font-size: 0.2rem;
//       font-weight: 400;
//       color: #1f1f1f;
//       line-height: 0.24rem;
//       background:#f5f5f5;
//       border-bottom: none;
//       padding: 0.3rem 0;
//     }
//     &::before {
//       background: none;
//     }
//   }
//   .td-word-sm {
//     font-size: 0.16rem;
//     font-weight: 400;
//     color: #929dad;
//     line-height: 0.19rem;
//   }
// }
</style>
